module.exports = {
	"header": "Selling on $t(general::brand)",
	"subHeader": "Seller services & features",
	"paragraph1": "We offer solutions for auctioneers and auction houses across the globe, whatever their language or specific needs are. We have 10 years of experience in auctioning and live auctioning systems and we now share this expertise and offer solutions through the $t(general::brand) platform.",
	"paragraph2": "We give you the opportunity to reach thousands of potential new customers, resulting in fewer unsold items and in increased hammer prices on your sales.",
	"dashboard": {
		"header": "Seller account and seller dashboard",
		"paragraph1": "You can register now as a seller and, using the seller dashboard, provide your customers with free catalog listings for the lots in your auctions, including descriptions, pictures and much more."
	},
	"premiumAccount": {
		"header": "Premium account",
		"paragraph1": "You can also register for a premium account in order to be able to use the $t(general::brand) live platform and receive bids in real time wherever your customers are, no need for them to be in person on the premises of your event.",
		"paragraph2": "Your customers can bid at home, at the office or on the go using their mobile devices."
	},
	"absenteeBidding": {
		"header": "Absentee Bidding",
		"paragraph1": "Potential buyers can leave absentee bids in advance of the auction event. Their bids are considered as the maximum and everything will be managed automatically. The starting bid of the event will be the high bid of the absentee bid."
	},
	"liveBidding": {
		"header": "Live Bidding",
		"paragraph1": "Allows buyers to place bids at the same time the auction is taking place on the premises of the event. Bidders can place bid using their computer or mobile device."
	},
	"bidderManagement": {
		"header": "Bidder Management",
		"paragraph1": "This feature of the seller dashboard enables you to review, authorize or disapprove of bidders based on their profile. You can do this manually or automatically depending on your preferences. You can also create lists of customers and set certain bidding and buying limits for that group of bidders."
	},
	"photoUpload": {
		"header": "Photo Upload",
		"paragraph1": "Using the seller dashboard you can upload your item pictures using your web browser."
	},
	"automatedConsole": {
		"header": "Automated auction console",
		"paragraph1": "Gives you the possibility to run your live event on the auto-pilot in an unmanned fashion in cases were all of your bidders are online."
	},
	"endReport": {
		"header": "End-of-auction report",
		"paragraph1": "Get a detailed report during and after every auction, provides various statistics and metrics."
	},
	"customization": {
		"header": "Customization and integration",
		"paragraph1": "You can customize the live bidding console and integrate the console directly on your website."
	},
	"api": {
		"header": "API Integration",
		"paragraph1": "You can integrate your current information and management systems with our database and ease the process of publishing your auctions as well as accessing the most up to date information about your events."
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/selling.json5
// module id = 1958
// module chunks = 6